// extracted by mini-css-extract-plugin
export var item = "fs_vs";
export var text = "fs_hw";